import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=110ba2a8&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=110ba2a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110ba2a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainNav: require('/app/components/MainNav.vue').default,SubNav: require('/app/components/SubNav.vue').default,SvgBurger: require('/app/components/svg/Burger.vue').default,SvgClose: require('/app/components/svg/Close.vue').default})
